import { createAsyncThunk } from "@reduxjs/toolkit";
import orderApi from "./api";

export const getOrderList = createAsyncThunk("orders/get/loading", async (data) => {
  return orderApi.getOrderList(data);
});

export const doDeleteOrder = createAsyncThunk("orders/delete/loading", async (id) => {
  return orderApi.delete(id);
});

export const doCreateActiveOrder = createAsyncThunk(
  "orders/create/loading",
  async (data) => {
    return orderApi.createActiveOrder(data);
  }
);

export const doGetOrder = createAsyncThunk("orders/active/loading", async (data) => {
  return orderApi.getOrder(data);
});
export const doGetOrderRoutes = createAsyncThunk(
  "order-routes/active/loading",
  async (data) => {
    return orderApi.getOrderRoutes(data);
  }
);

export const doGetJobOrder = createAsyncThunk("orders/job/loading", async (data) => {
  return orderApi.getJobOrder(data);
});
export const doOptimizeOrder = createAsyncThunk(
  "orders/optimize/loading",
  async (data) => {
    await orderApi.optimizeOrder(data);
    return true;
  }
);

export const doOptimizeOrderCallback = createAsyncThunk(
  "orders/optimize-callback/loading",
  async (data) => {
    const { order, vehicleCategoryList, isSelectRouteNumber, numberRoutes } = data;
    return {
      output: data?.output,
      order,
      vehicleCategoryList,
      isSelectRouteNumber,
      numberRoutes
    };
  }
);

export const doSortOrderCallback = createAsyncThunk(
  "orders/sortOrder-callback/loading",
  async (data) => {
    const { order, vehicleCategoryList, isSelectRouteNumber, numberRoutes } = data;
    // let result = {};
    // result = await orderApi.sortOrderRoute(data);
    return {
      output: data?.output,
      order,
      vehicleCategoryList,
      isSelectRouteNumber,
      numberRoutes
    };
  }
);

/**
 * Builds routes without the routing engine: predefined_osrm, osrm_optimize or bypass.
 *
 * Resolves to the same payload shape as doSortOrderCallback so it can reuse that reducer.
 * `preserveOrder` tells the reducer to trust the solution's array order rather than re-sorting
 * by arrival_time, which would silently reshuffle stops sharing an arrival minute. It is
 * always set here: this endpoint emits stops in their final sequence for every mode — as
 * submitted for predefined_osrm/bypass, and as OSRM ordered them for osrm_optimize.
 */
export const doFixedOrderRoute = createAsyncThunk(
  "orders/fixedOrder/loading",
  async (data) => {
    const { order, vehicleCategoryList, isSelectRouteNumber, numberRoutes } = data;
    const result = await orderApi.fixedOrderRoute(data);
    return {
      output: result?.output,
      degraded: result?.degraded,
      order,
      vehicleCategoryList,
      isSelectRouteNumber,
      numberRoutes,
      preserveOrder: true
    };
  }
);
export const doSortOrder = createAsyncThunk("orders/sortOrder/loading", async (data) => {
  await orderApi.sortOrderRoute(data);
  return true;
});

export const doStoreDraftId = createAsyncThunk(
  "orders/doStoreDraftId/loading",
  (data) => {
    return data;
  }
);
